import { render, staticRenderFns } from "./CardTicketUtm.vue?vue&type=template&id=7a8ab9fc&scoped=true"
import script from "./CardTicketUtm.vue?vue&type=script&lang=js"
export * from "./CardTicketUtm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8ab9fc",
  null
  
)

export default component.exports